import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import firebase from 'firebase'
import LandingPage from './views/LandingPage.vue'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Privacy from './views/Privacy.vue'
import Tutorial1 from './views/tutorial/Tutorial1.vue'
import Tutorial2 from './views/tutorial/Tutorial2.vue'
import Tutorial3 from './views/tutorial/Tutorial3.vue'
import Tutorial4 from './views/tutorial/Tutorial4.vue'

Vue.use(Router)

const router = new Router({
	mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
			component: Home,
			meta: { requiresAuth: true }
    },
    {
      path: '/ios',
      name: 'ios',
			component: LandingPage,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      // component: () => import('./views/Login.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
			meta: { requiresAuth: true }
    },{
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },
    {
      path: '/tutorial1',
      name: 'tutorial1',
      component: Tutorial1,
    },
    {
      path: '/tutorial2',
      name: 'tutorial2',
      component: Tutorial2,
    },
    {
      path: '/tutorial3',
      name: 'tutorial3',
      component: Tutorial3,
    },
    {
      path: '/tutorial4',
      name: 'tutorial4',
      component: Tutorial4,
    },
  ]
})

router.beforeEach((to, from, next) => {
	let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

	if (requiresAuth) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          path: '/ios',
        })
      }
    })
  } else {
    next()
  }
})

export default router
